// eslint-disable-next-line max-len
const actionReplayMiddleware = (actionsToWatch, callback = null) => ({ dispatch }) => (next) => (action) => {
    const result = next(action)
    if (actionsToWatch.includes(action.type)) {
        callback({ action, dispatch })
    }
    return result
}

export default actionReplayMiddleware
